import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import JoditEditor from "jodit-react";
import { ProtectAPi } from '../../../../../api/ProtectAPi';
import swal from 'sweetalert';
import BackButton from '../../../../tools/BackButton';

const FactoryInfoAdd = () => {
    const { http } = ProtectAPi();
    const editor = useRef(null);
    const navigate = useNavigate();
    const [loader, setLoader] = useState('off');
    const [url, setUrl] = useState('');
    const [title, setTitle] = useState('');
    const [isVideoOrImage, setIsVideoOrImage] = useState(null);
    const [description, setDescription] = useState('');
    const [infoTypeError, setInfoTypeError] = useState('');
    const [titleError, setTitleError] = useState('');
    const [descriptionError, setDescriptionError] = useState('');
    const [layoutImage, setLayoutImage] = useState(null);
    const [layoutImageError, setLayoutImageError] = useState('');
    const [imagePreview, setImagePreview] = useState('');

    // 🔹 New Alt Text State
    const [altText, setAltText] = useState('');
    const [altTextError, setAltTextError] = useState('');

    const submitForm = () => {
        setLoader('on');
        setInfoTypeError('');
        setTitleError('');
        setDescriptionError('');
        setLayoutImageError('');
        setAltTextError('');

        const formData = new FormData();
        formData.append('info_url', url);
        formData.append('info_title', title);
        formData.append('description', description);
        formData.append('image', layoutImage);
        formData.append('info_type', isVideoOrImage);
        formData.append('alt', altText); // 🔹 Send alt text

        http.post(`/add-our-factory-info`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(res => {
            if (res.data.status === '422') {
                const errors = res.data.error;
                setLoader('off');
                setInfoTypeError(errors.info_type ? errors.info_type[0] : '');
                setTitleError(errors.info_title ? errors.info_title[0] : '');
                setDescriptionError(errors.description ? errors.description[0] : '');
                setLayoutImageError(errors.image ? errors.image[0] : '');
                setAltTextError(errors.alt ? errors.alt[0] : '');
            } else {
                setLoader('off');
                navigate('/admin/pages/our-factory-info-list');
                swal('Success', res.data.msg, 'success');
            }
        }).catch(error => {
            console.error('Error:', error);
            setLoader('off');
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'layoutTitle') {
            setTitle(value);
        } else if (name === 'url') {
            setUrl(value);
        }
    };

    const handleImageChange = (e) => {
        const selectedImage = e.target.files[0];
        setLayoutImage(selectedImage);
        const previewURL = URL.createObjectURL(selectedImage);
        setImagePreview(previewURL);
    };

    const editorConfig = useMemo(() => ({
        readonly: false,
        placeholder: 'Start typing...',
        uploader: {
            insertImageAsBase64URI: true
        }
    }), []);

    return (
        <div className="main-content">
            <section className="section">
                <div className="section-body">
                    <div className="row">
                        <div className="col-12">
                            <div className="card card-primary">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between">
                                        <h5>Factory Information</h5>
                                        <BackButton />
                                    </div>
                                    <div className="card-body pb-0">
                                        <div className="row">
                                            {/* Title */}
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Title</label>
                                                    <input type="text" name="layoutTitle" value={title} className="form-control" placeholder="Title" onChange={handleInputChange} />
                                                    <span className="text-danger">{titleError}</span>
                                                </div>
                                            </div>

                                            {/* Type Selection */}
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Show Type</label>
                                                    <select className="form-control selectric rounded" value={isVideoOrImage} onChange={e => setIsVideoOrImage(e.target.value)}>
                                                        <option value="">Select</option>
                                                        <option value="1">Image</option>
                                                        <option value="0">Youtube Video</option>
                                                    </select>
                                                    <span className="text-danger">{infoTypeError}</span>
                                                </div>
                                            </div>

                                            {/* YouTube URL */}
                                            {isVideoOrImage === '0' && (
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Youtube URL</label>
                                                        <input type="text" name="url" value={url} className="form-control" placeholder="Youtube Embed URL" onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                            )}

                                            {/* Image Upload + Alt Text */}
                                            {isVideoOrImage === '1' && (
                                                <>
                                                    <div className="col-md-6">
                                                        <label>Image</label>
                                                        <div className="logo-box mt-3">
                                                            <div className="logo">
                                                                <label htmlFor="layoutImage">
                                                                    <div className="image-box border dottet p-2 rounded">
                                                                        {imagePreview ? (
                                                                            <img src={imagePreview} className="img-fluid" alt="Preview" />
                                                                        ) : (
                                                                            <img src="https://w7.pngwing.com/pngs/159/705/png-transparent-computer-computer-trademark-computer-logo.png" className="img-fluid" alt="Default" />
                                                                        )}
                                                                    </div>
                                                                    <input type="file" id="layoutImage" className="form-control d-none" onChange={handleImageChange} />
                                                                    <span className="btn btn-primary mt-1 w-100">Upload Image</span>
                                                                    <span className="text-danger">{layoutImageError}</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <div className="form-group mt-3">
                                                            <label>Image Alt Text</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Enter image alt text"
                                                                value={altText}
                                                                onChange={(e) => setAltText(e.target.value)}
                                                            />
                                                            <span className="text-danger">{altTextError}</span>
                                                        </div>
                                                    </div>
                                                </>
                                            )}

                                            {/* Description */}
                                            <div className="col-md-12 mt-4">
                                                <label>Description</label>
                                                <JoditEditor
                                                    ref={editor}
                                                    value={description}
                                                    config={{
                                                        readonly: false,
                                                        height: 400,
                                                        placeholder: 'Start typing...',
                                                        uploader: {
                                                            insertImageAsBase64URI: true
                                                        }
                                                    }}
                                                    tabIndex={1}
                                                    onBlur={newContent => setDescription(newContent)}
                                                    onChange={() => { }}
                                                />
                                                <span className="text-danger">{descriptionError}</span>
                                            </div>


                                            <div className="col-md-12 mt-5 mb-4">
                                                {loader === 'off' ? (
                                                    <button type="submit" onClick={submitForm} className="btn btn-lg btn-primary">Submit</button>
                                                ) : (
                                                    <div className="spinner-border text-dark" role="status"></div>
                                                )}
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default FactoryInfoAdd;
